export default __webpack_public_path__ + "static/media/SG-LightBlue-0002.16d8cc3f.png";